import * as React from 'react'
import Panoramax from '@panoramax/web-viewer';
import '@panoramax/web-viewer/build/index.css';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'pnx-viewer': PnxViewerProps
    }
  }
}

interface PnxViewerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  endpoint: string
  focus?: string
  "map-options"?: string
}

interface PanoramaxViewerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  address: any
}

export default function PanoramaxViewer({ address, ...props }: PanoramaxViewerProps) {
    const test = Panoramax
    return <pnx-viewer 
        endpoint={`https://api.panoramax.xyz/api`} 
        focus="pic"
        map-options={`{"zoom": 19.51, "center": { "lat": ${address.value.latitude}, "lon": ${address.value.longitude} } }`}
        {...props} 
    />
}
